// extracted by mini-css-extract-plugin
export default {"container":"container---KWbIG","link":"link---GBN0P","externalLink":"externalLink---LNfxb"};